export enum CDFStream {
  PRODUCT_SHEET = "PRODUCT SHEET",
  BATT = "BATT",
  PACK = "PACK",
  WEEE = "WEEE",
  BUNDLE = "BUNDLE INFORMATION"
}
